import { useEffect } from "react";
import { AppProviders } from "@/app/AppProviders";
import { AppRoutes } from "@/app/AppRoutes";
import { GlobalStyle } from "@/shared/theme/GlobalStyle";
import { AppTooltipGlobalStyle } from "@/shared/components/Tooltip/AppTooltip";
import { installGlobalErrorListeners } from "@/shared/lib/userLog";
import { trackKeyboard } from "@/shared/lib/keyboardTracker";

installGlobalErrorListeners();

function App() {
	// Phone bottom bars step aside while the on-screen keyboard is up.
	useEffect(() => trackKeyboard(), []);

	return (
		<>
			<GlobalStyle />
			<AppTooltipGlobalStyle />
			<AppProviders>
				<AppRoutes />
			</AppProviders>
		</>
	);
}

export default App;
